import { Extension } from '@tiptap/core'
import '@tiptap/extension-text-style'

interface BackgroundColorOptions {
    types: string[]
}

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        textBackgroundColor: {
            setTextBackgroundColor: (backgroundColor: string) => ReturnType
            unsetTextBackgroundColor: () => ReturnType
        }
    }
}

/** Adds an inline background color to selected text using the existing textStyle mark. */
export const BackgroundColor = Extension.create<BackgroundColorOptions>({
    name: 'textBackgroundColor',

    addOptions() {
        return { types: ['textStyle'] }
    },

    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    backgroundColor: {
                        default: null,
                        parseHTML: (element) => element.style.backgroundColor || null,
                        renderHTML: (attributes) => (attributes.backgroundColor ? { style: `background-color: ${attributes.backgroundColor}` } : {}),
                    },
                },
            },
        ]
    },

    addCommands() {
        return {
            setTextBackgroundColor:
                (backgroundColor) =>
                ({ chain }) =>
                    chain().setMark('textStyle', { backgroundColor }).run(),
            unsetTextBackgroundColor:
                () =>
                ({ chain }) =>
                    chain().setMark('textStyle', { backgroundColor: null }).removeEmptyTextStyle().run(),
        }
    },
})
